<template>
  <div class="forex px-2 lg:px-0">
    <div class="forex-1">
      <div class="container mx-auto py-20 lg:grid lg:grid-cols-5 gap-4 items-center">
        <div class="px-2 pl-2 flex flex-col col-span-3 lg:px-20 lg:pl-32">
          <div class="font-semibold text-5xl text-main">{{ trades.title }}</div>
          <div class="text-base text-sub-title pr-20 py-8 description" v-html="trades.description"></div>
          <div class="button">
            <a :href="options.openTradingAccountLink">
              <el-button class="px-2 py-3 rounded-lg lg:px-4" style="margin-bottom: 10px;" type="danger">{{
                options.openTradingAccountText
                }}</el-button>
            </a>
            <a :href="options.openDemoAccountLink" class="ml-2">
              <el-button class="px-2 py-3 rounded-lg lg:px-4" style="margin-bottom: 10px;">{{
                options.openDemoAccountText }}</el-button>
            </a>
          </div>
        </div>
        <div v-show="!xsShow" class="col-span-2">
          <!-- <img src="../../assets/images/products/top-right.svg"/> -->
          <!-- <img src="../../assets/images/products/top-right2.svg"/> -->
          <img :src="$path + trades.image?.data?.attributes?.url" />
        </div>
      </div>
    </div>
    <div class="forex-2">
      <div class="pt-10 container md:mx-auto flex items-center h-full lg:pt-0">
        <div class="flex flex-col lg:pr-60">
          <div class="font-semibold text-4xl text-main mb-2">{{ trades.titleTrade }}</div>
          <div v-html="trades.descriptionTrade"></div>
        </div>
      </div>
    </div>
    <div class="forex-3 py-20 border-t border-gray-100">
      <div class="container md:mx-auto h-full">
        <div class="flex flex-col">
          <el-card shadow="always" class="rounded-2xl w-full">
            <el-table height="560px" :data="spreadTableData" :size="xsShow ? 'mini' : 'large'"
              :row-style="{ height: '64px', color: '#475467' }" :header-row-style="{ color: '#101828' }"
              :header-cell-style="{ background: '#F9FAFB' }" stripe style="width: 100%">
              <el-table-column :prop="item" align="center" :label="translations.trade[item]"
                v-for="item in trade_fields_display" :key="item" min-width="130px">
              </el-table-column>
            </el-table>
            <p class="font-semibold text-menu-title mt-4">{{ $t('products.stocksCFD.stocksCFD3.notes') }}</p>
            <p class="text-sub-title mt-2" v-html="trades.notice"></p>
          </el-card>
        </div>
      </div>
    </div>
    <div class="forex-4">
      <go-register></go-register>
    </div>
    <div class="forex-5">
      <div class="container md:mx-auto h-full py-20">
        <div class="font-semibold text-3xl text-main text-center">{{ trades.titleQuestion }}</div>
        <el-collapse class="mt-16 px-2 lg:px-0" v-model="activeAry">
          <el-collapse-item :title="item.title" :name="index" v-for="(item, index) in trades.questions" :key="item.id">
            <div v-html="item.description"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
import { mapGetters } from 'vuex'
import goRegister from '../global/goRegister'
import { getTrades } from '@/api/trades'
export default {
  name: 'Home',
  data() {
    return {
      active: 'one',
      itemActive: 'spread1',
      trades: {},
      spreadTableData: [],
      trade_fields_display: [],
      swapTableData: [],
      activeAry: [0, 1],
      xsShow: false, // 手机显示
      activeWidth: window.innerWidth
    }
  },
  watch: {
    activeWidth: {
      handler(val, oldVal) {
        if (val <= 416) {
          this.xsShow = true
        } else {
          this.xsShow = false
        }
      },
      deep: true, // true 深度监听
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      lang: 'getLang'
    }),
    lang() {
      return this.$store.state.lang
    },
    options() {
      return this.$store.getters.options
    },
    translations() {
      return this.$store.getters.translations
    }
  },
  components: { goRegister },
  created() {
    this.getTrades()
  },
  mounted() {
  },
  methods: {
    async getTrades() {
      const params = {
        'populate[trades][populate][trades][fields]': '*',
        'populate[trades][populate][questions][fields]': '*',
        'populate[trades][filters][name][$eq]': 'forex',
        'populate[trades][populate][image][fields]': 'url'
      }
      const result = await getTrades(params)
      this.trade_fields_display = result.data.attributes?.options.trade_fields_display
      this.trades = result.data.attributes?.trades[0] || {}
      this.spreadTableData = this.trades.trades
    },
    activeTab(tab) {
      this.active = tab
    }
  }
}
</script>

<style lang="less" scoped>
.forex {
  .forex-1 {
    height: 682px;
    background: url("../../assets/images/home/advantage.svg");
  }

  .forex-2 {
    height: 384px;
    background: url("../../assets/images/products/fg.svg");

    ul {
      li {
        list-style-type: disc;
      }
    }
  }

  .forex-3 {
    height: 958px;
    background: url("../../assets/images/products/forex.svg") no-repeat;
    background-position: right top;
    // background-position: top;

    .choice-tabs {
      background: linear-gradient(0deg, #EAECF0, #EAECF0),
        linear-gradient(0deg, #F9FAFB, #F9FAFB);
    }
  }

  .forex-4 {
    background: url("../../assets/images/home/registerNow-bg2.svg") no-repeat;
    background-size: cover;
  }

  .forex-5 {
    background: url("../../assets/images/home/platform-bg.svg");
    background-size: contain;
  }
}

@media screen and (max-width: 768px) {
  .forex {

    .forex-1,
    .forex-2,
    .forex-3,
    .forex-4 {
      height: auto;
      margin-bottom: 30px;
      /*background: url("../../assets/images/products/top-right.svg");*/
    }

    .forex-1 {
      .button {
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        // justify-content: center;

      }

      .description {
        padding-right: 0;
      }
    }
  }
}
</style>
